import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e5a3f3a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4e5a3f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a3f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e5a3f3a')) {
      api.createRecord('4e5a3f3a', component.options)
    } else {
      api.reload('4e5a3f3a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e5a3f3a&scoped=true&", function () {
      api.rerender('4e5a3f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/contractBasicInfo/index.vue"
export default component.exports